
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendor",
      function () {
        return require("private-next-pages/vendor/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendor"])
      });
    }
  